package com.vamvisions.main.portfolio.domain.model

import com.vamvisions.main.core.domain.preferences.Language

/**
 * A markdown document, such as a privacy policy, in one [language]. [markdown] is the raw source and
 * [updatedAt] is an ISO-8601 date.
 */
data class Document(
    val slug: String,
    val language: Language,
    val title: String,
    val markdown: String,
    val updatedAt: String,
)
